import { render, staticRenderFns } from "./ChartsForm.vue?vue&type=template&id=12cb6188"
import script from "./ChartsForm.vue?vue&type=script&lang=js"
export * from "./ChartsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports